<template>
  <div :class="{card: true, active:isActive}">
    <div class="card-body">
      <div @click="showInfo = !showInfo" style="cursor: pointer;">
        <div>
        <h5 class="element">
          <span class="triangle" v-html="triangleIcon"></span>
         {{city.name}}
        </h5>
        <h5 class="right">{{formatNumber(city.scores.score)}}</h5>
        </div>
      </div>
      <div v-if="showInfo">
        <div layout="row top-justify">
          <div class="cell">Instagram</div>
          <!--<div class="cell cell-center">{{formatNumber(city.scores.instagramPosts)}}</div>-->
          <div class="cell cell-right">{{formatNumber(city.scores.instagram)}}</div>
        </div>
        <div layout="row top-justify">
          <div class="cell">Interactive Wall</div>
          <!--<div class="cell cell-center">{{formatNumber(city.scores.quizs)}}</div>-->
          <div class="cell cell-right">{{formatNumber(city.scores.quiz)}}</div>
        </div>
        <div layout="row top-justify">
          <div class="cell">AR App</div>
          <!--<div class="cell cell-center">{{formatNumber(city.scores.testDrives)}}</div>-->
          <div class="cell cell-right">{{formatNumber(city.scores.testDrive)}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "DashboardCity",
    props: ['city'],
    methods: {
      formatNumber(score) {
        return score.toLocaleString('de-DE');
      }
    },
    computed: {
      triangleIcon: function()  {
        return this.showInfo ? '&#9660' : '&#9658';
      }
    },
    data() {
      return {
        showInfo: false,
        isActive: this.city.isActive
      }
    }
  }
</script>

<style scoped>
  .card {
    width: 100%;
  }

  .triangle {
    font-size: 1rem;
  }
  .active {
    border: orangered solid 3px;
    color: orangered;

  }

  h5 {
    font-weight: bold;
  }

  .element {
    float: left;
  }

  .right {
    float: right;
  }

  .card-body {
    padding: 0.5rem;
  }

  .cell {
    width: 33%;
  }

  .cell-center {
    text-align: center;
  }

  .cell-right {
    text-align: right;
  }

</style>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardCity.vue